module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL1-if-correct.0c2c5fe7.mp3";